import sentry from '../../sentry';
import { Heading, Center, VStack, Text, Link } from '@chakra-ui/react';
import { FORM_PADDING_TOP_XL } from '../../utils/consts';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { HttpContext } from '../../context/HttpContext';
import {
  CustomLockMultiIcon,
  CustomUnlockedLockMultiIcon,
} from '../../theme/multicolor-icons/CustomLockMultiIcon';

function UnlockAccountPage() {
  const { token } = useParams();
  const { publicAxios } = useContext(HttpContext);
  const [accountUnlocked, setAccountUnlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accountAlreadyUnlocked, setAccountAlreadyUnlocked] = useState(false);

  useEffect(() => {
    const unlockAccount = async () => {
      try {
        setIsLoading(true);
        const response = await publicAxios.post(`accounts/unlock/${token}`);

        if (response.status === 200) {
          if (response.data?.already_unlocked) {
            setAccountAlreadyUnlocked(true);
          }
          setAccountUnlocked(true);
        }
      } catch (onError) {
        sentry.sendError(onError);
        if (
          onError.response?.data?.error
            ?.toLowerCase()
            .includes('already unlocked')
        ) {
          setAccountAlreadyUnlocked(true);
          setAccountUnlocked(true);
        } else {
          setError(
            onError.response?.data?.error ||
              'An error occurred while unlocking your account'
          );
        }
        console.log(onError);
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      unlockAccount();
    }
  }, [token, publicAxios]);

  return (
    <>
      {isLoading ? (
        <Center pt={FORM_PADDING_TOP_XL} pb="10px">
          <VStack spacing={2}>
            <CustomLockMultiIcon width="70" height="70" />
            <Heading size="2xl" textAlign="center">
              Unlocking your account...
            </Heading>
            <VStack spacing={5}>
              <Text textStyle="bodyRoman" color="secondaryDark08">
                Please be patient.
              </Text>
            </VStack>
          </VStack>
        </Center>
      ) : accountUnlocked ? (
        <Center pt={FORM_PADDING_TOP_XL} pb="10px">
          <VStack spacing={2}>
            <CustomUnlockedLockMultiIcon width="70" height="70" />
            <Heading mt={4} size="2xl" textAlign="center">
              {accountAlreadyUnlocked
                ? 'Your account is already unlocked!'
                : 'Your account has been unlocked!'}
            </Heading>
            <VStack spacing={5}>
              <Text textStyle="bodyRoman" color="secondaryDark08">
                You can now login to your account.
              </Text>
              <Text textStyle="bodyRoman" color="secondaryDark08">
                If you don't remember your password, you can{' '}
                <Link href="/forgot-password" color="#FF4935">
                  reset your password here
                </Link>
                .
              </Text>
            </VStack>
          </VStack>
        </Center>
      ) : (
        <Center pt={FORM_PADDING_TOP_XL} pb="10px">
          <VStack spacing={2}>
            <CustomLockMultiIcon width="70" height="70" />
            <Heading mt={4} size="2xl" textAlign="center">
              Error unlocking account
            </Heading>
            <VStack spacing={5}>
              <Text textStyle="bodyRoman" color="secondaryDark08">
                {error || 'The unlock token may be invalid or expired.'}
              </Text>
              <Text textStyle="bodyRoman" color="secondaryDark08">
                Your account may already be unlocked. Please try to login again
                or contact support at{' '}
                <Link href="mailto:support@passentry.com" color="#FF4935">
                  support@passentry.com
                </Link>
                .
              </Text>
            </VStack>
          </VStack>
        </Center>
      )}
    </>
  );
}

export default UnlockAccountPage;
